/**
 * components/inspection/monitoringScope.js
 * МОНИТОРИНГ (байнгын хяналт) ХИЙДЭГ НЭГЖИЙГ тулгах ЦОР ГАНЦ дүрэм.
 *
 * Хэрэглэгч (2026-10-28): «мониторингоор явдаг БН-н бүртгэл … энэ БН-д л
 * энэ хяналт хийх товч харагддаг болгох».
 *
 * ━━ ЯАГААД ТУСДАА ФАЙЛ ВЭ ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * Сервер нь НЭВТЭРСЭН хүний нэгжийг `covered` гэж өөрөө буцаадаг
 * (`/xab/bn-monitoring`). Гэвч шалгалт эхлүүлэхэд хэрэглэгч ӨӨР нэгж
 * сонгож болно (ХАБЭА хэлтсийн мэргэжилтэн бүх цехэд шалгадаг) — тэр
 * үед «сонгосон нэгж бүртгэлтэй эсэх»-ийг КЛИЕНТ талд бодох шаардлага
 * гарна. Дүрмийг хоёр газар бичвэл хожим зөрөх тул ЭНД нэг л удаа
 * бичиж, серверийн `BnMonitoring.covers()`-ийн ЯГ тусгал болгов.
 *
 * ━━ ДҮРЭМ ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 *   • бүртгэлийн `bn_code` ХООСОН  → тэр ЦЕХИЙН бүх хэсэг хамаарна
 *   • бүртгэлийн `bn_code` БИЙ     → шалгах код тэр кодоор ЭХЛЭХ ёстой
 *     (хэсэг «2401» → групп «240101» ч хамаарна — кодын шатлал
 *     угтвартай: цех 2 орон → хэсэг 4 → групп 6)
 *
 * ⚠ ХЭСЭГ ТОДОРХОЙГҮЙ үед ЗӨВХӨН цехийн хэмжээний бүртгэл хүчинтэй.
 *   Эс бөгөөс «цех 24-ийн хэсэг 2405-д л мониторинг хийдэг» гэсэн
 *   бүртгэлээр хэсэг сонгоогүй хэрэглэгчид товч гарч, бүртгэлгүй
 *   хэсэгт мониторинг эхлүүлнэ.
 *
 * ⚠ ЦЕХ нь ЯГ ТЭНЦҮҮГЭЭР тулгана, угтвараар БИШ: цех «2» нь «24»-ийн
 *   угтвар бөгөөд угтвараар тулгавал цех 2 бүртгэлтэй бол 24 · 25 · 28
 *   бүгд «хамаарна» гэж гарна.
 */

/** Сонгосон нэгж (цех + хэсэг) мониторингийн бүртгэлд хамаарч байна уу. */
export function coversUnit(items, tsehCode, bnCode) {
  const t = String(tsehCode || "").trim();
  if (!t) return false;
  const rows = (items || []).filter(
    (r) => String(r?.tseh_code || "").trim() === t,
  );
  if (!rows.length) return false;
  const want = String(bnCode || "").trim();
  return rows.some((r) => {
    const reg = String(r?.bn_code || "").trim();
    if (!reg) return true; // цех даяар
    return !!want && want.startsWith(reg);
  });
}

/** Мониторинг хийдэг ЦЕХИЙН кодуудын олонлог (шүүлт/тэмдэглэгээнд). */
export function monitoringTsehCodes(items) {
  const out = new Set();
  (items || []).forEach((r) => {
    const t = String(r?.tseh_code || "").trim();
    if (t) out.add(t);
  });
  return out;
}

export default coversUnit;
